// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__EGObk","footer-heading":"footer_footer-heading__wvbCo","footer-list":"footer_footer-list__7fJ-k","contact-info":"footer_contact-info__PgKmg"};